import useSWR from "swr";

export const useProductionCategories = (searchQuery) => {
    const clientsKey = searchQuery ? `/production-category/search-productions-categories?searchParams=${searchQuery}` : `/production-category`;
    const { data, error, mutate } = useSWR(clientsKey);

    return {
        production_categories: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};